import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import Image from "next/image";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";

function RealtimeRiskModal({ setModalOpen, isModalOpen }: any) {
  const router = useRouter();
  const { t } = useTranslation("detail");
  const modalRef = useModalClickOutside(setModalOpen);

  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="gap-[17px]"
    >
      <h1 className={`${TYPO.TYPO5_SB} text-gray80`}>
        {t("whatIsRealtimeRisk")}
      </h1>

      <div className="flex justify-center w-full ">
        <Image
          width={327}
          height={163}
          src={
            router.locale === "en"
              ? `/images/detail/RealtimeRiskEn.png`
              : `/images/detail/RealtimeRiskKr.png`
          }
          alt="file"
        />
      </div>
      <div className="w-full  p-5 bg-gray5 rounded-[10px] flex-col justify-start items-start gap-[5px] inline-flex">
        <div className="w-full whitespace-pre-line !text-[17px] break-keep">
          <span className={`${TYPO.TYPO5_MD} text-gray60  !text-[17px] `}>
            {t("RealtimeRiskDescription1")}
          </span>
          <span className={`${TYPO.TYPO5_SB} text-gray80  !text-[17px]`}>
            {t("RealtimeRiskDescription2")}
          </span>
          <span className={`${TYPO.TYPO5_MD} text-gray60  !text-[17px]`}>
            {t("RealtimeRiskDescription3")}
          </span>
        </div>
      </div>
      <div className="w-full mt-[3px] flex gap-2">
        <Button
          type={"tertiary"}
          size={"lg"}
          text={t("confirm")}
          width="whitespace-nowrap min-w-[35%]"
          clickHandler={() => {
            setModalOpen(false);
          }}
        />
        <Button
          btnClass="grow"
          type="primary"
          text={t("checkRealtimeRisk")}
          size="lg"
          width="w-full"
          clickHandler={() => router.push("/realtime-risk")}
        />
      </div>
    </BottomModal>
  );
}
export default RealtimeRiskModal;
